<div [ngClass]="commonService.isHidden ?'':'container-fluid'">
    <div class="card-block" style="margin: 20px;">
        <div class="document-block mt-2">
            <!-- Name And Contact -->
            <div class="formSection">
                <div class="head">
                    <strong>Sale Report (Unit Category Wise)</strong>
                </div>
                <table>
                    <tr>
                        <th>Sr. No.</th>
                        <th>Unit Category</th>
                        <th>Total Units</th>
                        <th>Booked Units</th>
                        <th>Allotted Units</th>
                        <th>₹ - Sold Units</th>
                        <th>₹ Received</th>
                        <th>₹ Balanced</th>
                    </tr>
                    <tr *ngFor="let catSale of saleList; let i=index;">
                        <td><strong>{{i+1}}</strong></td>
                        <td><strong>{{catSale?.unitCategoryCode}}</strong></td>
                        <td><strong>{{catSale?.totalUnits}}</strong></td>
                        <td><strong>{{catSale?.unitsBooked}}</strong></td>
                        <td><strong>{{catSale?.unitsAllotted}}</strong></td>
                        <td class="numeric"><strong>{{catSale?.amountOfSoldUnits}}</strong></td>
                        <td class="numeric"><strong>{{catSale?.amountReceived}}</strong></td>
                        <td class="numeric"><strong>{{catSale?.balancedAmount }}</strong>
                        </td>
                    </tr>
                    <tr>
                        <th colspan="=2">Total</th>
                        <th></th>
                        <th>{{ totalUnitsSum }}</th>
                        <th>{{ totalUnitBookedSum }}</th>
                        <th>{{ totalUnitAlottedSum }}</th>
                        <th class="numeric">{{ totalAmountSoldUnit }}</th>
                        <th class="numeric">{{ totalAmountReceived }}</th>
                        <th class="numeric">{{ totalBalancedAmountSum }}</th>
                    </tr>
                </table>
            </div>
        </div>
    </div>
</div>